<template lang="pug">
	div
		sfc-sentry
		sfc-dfp
		sfc-heap
		#article-index.not-found-page(v-if="!error || (error.statusCode === 404 || error.statusCode === 500)")
			b-container#content-wrapper
				b-row.flex
					.col-md-12.no-padding.header-404
						.uh-oh
							h1 Oops! Page not found.
							p The page may have been removed, had its name changed, or is just temporarily unavailable. Use the search to find what you're looking for or browse through some of our most popular content below.

					b-col#main-col(md="12" sm="12" cols="12")
						b-row
							.col-md-12
								.tab-wrapper
									.tabs
										.tab(v-for="(tab, index) in tabs" @click="setActiveTab(index)" :class="{'active':tab.isActive}" :key="index" @set-active-tab="setActiveTab")
											span.tab-content
												| {{tab.name}}
												span.active-border

						b-row#columns
							b-col(md="4" sm="12" cols="12" :class="{'show-col':tabs[0].isActive,'hide-col':!tabs[0].isActive}")
								h2.sub-heading
									| 529 Basics
								p Learn more about how 529 plans work to help you reach your college savings goals.
								ul
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/what-is-a-529-plan") What is a 529 plan?
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/name-the-top-7-benefits-of-529-plans") Top 7 benefits of 529 plans
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/are-there-gift-and-estate-tax-benefits-for-529-plans") 529 gift & estate tax benefits
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/how-do-i-select-the-right-investments-for-my-529-plan") The right portfolio for your 529 plan
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/which-is-the-best-529-plan-available") The best 529 plans of 2019

							b-col(md="4" sm="12" cols="12" :class="{'show-col':tabs[1].isActive,'hide-col':!tabs[1].isActive}")
								h2.sub-heading
									| Common 529 Questions
								p Find answers to the most commonly asked questions investors have about 529 plans.
								ul
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/does-a-529-plan-affect-financial-aid") Does a 529 plan affect financial aid?
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/can-i-have-529-plans-from-multiple-states") Can I have 529 plans from multiple states?
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/are-529-plans-only-for-my-state-public-colleges") Can I use 529 plans outside of my state?
									li
										span
											a.blue(href="https://www.savingforcollege.com/intro-to-529s/what-is-the-penalty-on-an-unused-529-plan") What if I don't use my 529 plan?
									li
										span
											a.blue(href="https://www.savingforcollege.com/article/529-savings-plans-and-private-school-tuition") Can I use 529 plans for K-12 tuition?

							b-col(md="4" sm="12" cols="12" :class="{'show-col':tabs[2].isActive,'hide-col':!tabs[2].isActive}")
								h2.sub-heading
									| Tools & Calculators
								p Use our most popular tools and calculators to get answers to your questions.
								ul
									li
										span
											a.blue(href="https://www.savingforcollege.com/calculators/college-savings-calculator") College Savings Calculator
									li
										span
											a.blue(href="https://www.savingforcollege.com/calculators/financial-aid-calculator/") Financial Aid Calculator
									li
										span
											a.blue(href="https://www.savingforcollege.com/529-savings-vs-loans-calculator/") 529 vs. Loans Calculator
									li
										span
											a.blue(href="https://www.savingforcollege.com/compare-529-plans/") 529 plan comparison tool
									li
										span
											a.blue(href="https://www.savingforcollege.com/calculators/loan-calculator") Student Loan Calculator
						hr
				sfc-search(:disable-search-as-component="true")

		h1(v-else) {{error.message || "error"}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/general.styl'

	.not-found-page
		margin-bottom: 60px
		@media (max-width: 767px)
			padding-top: 15px

		#content-wrapper
			border: 1px solid sfc-pale-gray
			background: #fff

		.header-404
			margin-bottom: 50px
			@media (max-width: 767px)
				margin-bottom: 0px
			border-bottom: chart-blue-border
			border-top: chart-blue-border
			.uh-oh
				padding: 40px
				display: block
				position: relative
				background: sfc-blue-link
				color: #fff
				text-align: center
				p
					color: #fff
					max-width: 800px
					margin: 0 auto
					font-size: body-font-size-lg!important

		#main-col
			padding: 0 20px 10px
			ul
				padding-left: 15px
				li
					span
						font-size: body-font-size
						padding-left: 15px
						display: block
						a
							text-decoration: underline
			hr
				border-top: 1px solid sfc-pale-gray
			#columns
				padding: 0 15px
				@media (max-width: 767px)
					h2.sub-heading
						display: none !important
					.show-col
						display: block
					.hide-col
						display: none

		@media (max-width: 400px)
			>>>
				#search-page
					.search-box.search-box-small
						width: 75%

		.tab-wrapper
			-webkit-touch-callout: none
			-webkit-user-select: none
			-khtml-user-select: none
			-moz-user-select: none
			-ms-user-select: none
			user-select: none
			margin-bottom: 40px
			@media (min-width: 768px)
				display: none
			.tabs
				margin: 0
				background: transparent
				overflow-x: auto
				white-space: nowrap
				width: 100%
				scrollbar-width: none
				-ms-overflow-style: none
				&::-webkit-scrollbar
					width: 0
					height: 0
				.tab
					transition-all()
					display: inline-block
					color: sfc-gray-dark
					text-align: center
					border-right: 1px solid sfc-pale-gray
					border-top: 1px solid sfc-pale-gray
					border-bottom: 1px solid sfc-pale-gray
					padding: 10px 30px
					cursor: pointer
					background-color: #f1f4f7 !important
					&:hover
					&.active
						color: body-font-color
						border-bottom: 1px solid #f9fbfd !important
						background-color: #f9fbfd !important
						cursor: pointer
					overflow: -moz-scrollbars-none
					-ms-overflow-style: none
					.active-border
						display: none
					.tab-content
						font-size: body-font-size
						position: relative
						display: block
				&::-webkit-scrollbar
					height: 0

			@media (max-width: 767px)
				.tabs
					background-color: transparent
					position: relative
					.tab
					.tab:hover
						position: relative
						padding: 0 30px
						font-size: body-font-size
						background: transparent !important
						border: 0
						border-bottom: 1px solid sfc-pale-gray !important
						color: body-font-color
						.tab-content
							padding: 20px 0
						&.active
							background transparent !important
							border-bottom: 1px solid sfc-pale-gray !important
							color: sfc-blue-link
							.active-border
								display: block
								height: 3px
								background: sfc-blue-link
								position: absolute
								width: 100%
								bottom: -1px
					.fake-tab
						display: none
</style>

<script>
export default {
		layout: 'default_404',
		props: ['error'],
		data(){
			return{
				tabs: [
				{name: "529 Basics", isActive: true},
				{name:"Common 529 Questions", isActive: false},
				{name: "Tools & Calculators", isActive: false}
				],
				searchFor: ''
			}
		},
		async asyncData({store}){
			return{
				host: store.state.config.sfcHost
			}
		},
		methods: {
			deactiveAllTabs(){
				for(let tab of this.tabs){
					tab.isActive = false
				}
			},

			setActiveTab(index){
				this.deactiveAllTabs()
				this.tabs[index].isActive = true
				try{
					googletag.pubads().refresh()
				}catch(e){
				}
				this.$emit('click', index)
			},

		},
		head(){
			let result = {
				title: `404 - Page not found`,
				meta: [
					{name: 'robots', content: 'noindex'}
				],
				link: [
					{
						rel: 'canonical',
						href: this.host+this.$route.path
					}
				],
					__dangerouslyDisableSanitizers: ['title', 'meta', 'link']
			}

			return result
		}

}
</script>
